import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/returningLanding.module.css';

interface ReturningLandingProps {
  onOpenAbout: () => void;
  onLogin: () => void;
  onCreateAccount?: () => void;
}

export default function ReturningLanding({ onOpenAbout, onLogin, onCreateAccount }: ReturningLandingProps) {
  const handleStartOver = () => {
    // Clear the has_account flag to reset to pristine experience
    localStorage.removeItem("rc_has_account");
    // Force a page reload to trigger re-render
    window.location.reload();
  };

  return (
    <div className={styles.container}>
      <p className={styles.welcomeMessage}>Welcome back to your recovery journey</p>
      
      <div className={styles.cards}>
        <div className={styles.primaryCard}>
          <h3>My Journey</h3>
          <p>Login to pick up where you left off</p>
          <div className={styles.buttonGroup}>
            <button 
              onClick={onLogin}
              className={styles.loginButton}
            >
              Login
            </button>
            <button 
              onClick={onCreateAccount || onLogin}
              className={styles.createAccountButton}
            >
              Create Account
            </button>
          </div>
        </div>
        
        <div className={styles.secondaryCards}>
          <div className={styles.secondaryCard}>
            <h4>Assess</h4>
            <p>Am I an addict?</p>
            <Link to="/self-assess" className={styles.secondaryButton}>Take Self-Assessment</Link>
          </div>
          
          <div className={styles.secondaryCard}>
            <h4>Discover</h4>
            <p>Learn about addictions and recovery programs</p>
            <Link to="/discover" className={styles.secondaryButton}>Explore Programs</Link>
          </div>
        </div>
      </div>

      <div className={styles.startOverSection}>
        <button onClick={handleStartOver} className={styles.startOverButton}>
          New to Recovery Commons? Start Over
        </button>
      </div>
    </div>
  );
}
